import { render, staticRenderFns } from "./HoldKey.vue?vue&type=template&id=78676d01&"
import script from "./HoldKey.vue?vue&type=script&lang=js&"
export * from "./HoldKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports